import React, { Component } from 'react';
import { Grid , Typography, WithStyles,withStyles} from "@material-ui/core";
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import MyPATStepper from "../../../../../components/common/MyPATStepper";
import MyPATStep, { MyPATStepSubHeading, MyPATStepTitle } from "../../../../../components/common/MyPATStep";
import { StepStatus } from "../../../../common/types/Stepper";
import  ProgressBar from './ProgressBar';
import { connect } from 'react-redux';
import { ContentEvaluation } from "../../../types/Constants";
import { contentRequestActions } from '../../../reducers/trackProgressReducers';
import  RequestStepperProcess  from './RequestStepperProcess';
import { styles } from '../useStyles';
import { contentRequestAccordianActions } from '../../../reducers/contentRequestAccordianState';



interface TrackRequestProcessProps extends WithStyles<typeof styles> {
    totalCount:any,
    trackProgressData:any,
    testDetails:any,
    requestId:any, 
    accordianState:any, 
    contentRequestData:any, 
    progressBar :any,
    type:any,
    questionData:any,
    overallData:any,
    data:any,
    progressBarForQuestion:any,
    progressBarForTest:any,
    overallDone:any,
    setType: Function,
    typeOfContent:any,
    match:any,
}
interface TrackRequestProcessState {
    statusCreated: string, 
    statusEvaluted: string, 
    statusLang: string, 
    statusModerated: string, 
    statusPublished: string,
    progressCountPublisher: number,
    progressCountModerator: number,
    progressCountEvaluator: number,
    progressCountLangEval: number,
    progressCountCreator: number,
    hideProgressModerator: boolean,
    hideProgressEval: boolean,
    hideProgressLang: boolean,
    activeType: string,
    data :any, 
    overallData: any, 
    // totalCount: any
  }

 

const marginLeft = '900px';
const notYetStarted = 'Not Yet Started';
const inProgress = 'In Progress';
const createdBy = 'By You . 3:20 PM, 2nd Nov';


class TrackRequestProcess extends Component<TrackRequestProcessProps, TrackRequestProcessState> {
    constructor(props: any) {
        super(props);
        this.state = {
            statusCreated: StepStatus.PENDING,
            statusEvaluted: StepStatus.PENDING,
             statusLang: StepStatus.PENDING,
            statusModerated: StepStatus.PENDING,
            statusPublished: StepStatus.PENDING,
            progressCountPublisher: 0,
            progressCountModerator: 0,
            progressCountEvaluator: 0,
            progressCountLangEval: 0,
            progressCountCreator: 0,
            hideProgressModerator: false,
            hideProgressEval: false,
            hideProgressLang: false,
            activeType:((this.props.typeOfContent === 'test' && this.props.trackProgressData.length) || this.props.typeOfContent === 'question' || this.props.typeOfContent === 'Question')?'Question':'Test',
            data :{}, 
            overallData : {}, 
            }
    }

    percentageConvert = (totalCount: number, count: number) => {
        return Math.round(count*100/totalCount)
    }
    setActiveTab(event: any) {
        this.setState({
          activeType: event.target.id
        }, () => {
            const { setType } = this.props;
            setTimeout(() => {
                setType({ type: this.state.activeType })
            }, 50);
        });
    }

    questionAndTestTrackProgress = () => {
        const { activeType } = this.state;

        const { testDetails: { type = '', assignor={}} = {},  type: formatType, requestId, accordianState, contentRequestData, progressBar,progressBarForQuestion ,progressBarForTest,match} = this.props;
        const {testDetails,questionData,data,totalCount,overallDone } = this.props
        let check = this.props.type;
        const {overallData,trackProgressData, classes} = this.props;
        const len = this.props.questionData;
       
        return (
            <>
                <Typography
                    className={`${activeType === ContentEvaluation.contentEvaluation ? 'activeTab' : ''} subPanel `}
                    id={ContentEvaluation.contentEvaluation}
                    onClick={(e) => {
                        this.setActiveTab(e);
                    }}
                >
                    Content Creation
                </Typography>{" "}
               <Grid  className={classes.verticleLine} ></Grid>
                <Typography
                    id={ContentEvaluation.testEvaluation}
                    className={`${activeType === ContentEvaluation.testEvaluation ? 'activeTab' : ''} subPanel `}
                    onClick={(e) => {
                        this.setActiveTab(e);
                    }}
                >
                Test Compilation
                </Typography>
                {activeType === ContentEvaluation.contentEvaluation && (
                    <>
                        
                            
                        <RequestStepperProcess questionData={questionData} testDetails={testDetails} data={data} overallData={overallData} totalCount={totalCount} trackProgressData={trackProgressData} createdCount={progressBarForQuestion.count} requestType="question" overallDone={overallDone} match={match} />

                    </>
                )}
                {activeType === ContentEvaluation.testEvaluation && (
                    <>
                       
                        <RequestStepperProcess questionData={questionData} testDetails={testDetails}  data={data} overallData={overallData} totalCount={totalCount} trackProgressData={trackProgressData} createdCount={progressBarForTest.count} requestType="test" overallDone={overallDone} match={match} />
                    </>
                )}

            </>
        )
    }
    render() {
        const { testDetails: { type = '', assignor={}} = {},  type: formatType, requestId, accordianState, contentRequestData, progressBar,overallDone,match } = this.props;
        const {testDetails,questionData,data,totalCount,progressBarForQuestion,progressBarForTest } = this.props;
      
        let check = this.props.type;
        let requestType = check;
        const {overallData,trackProgressData} = this.props;
        const len = this.props.questionData;
        let createdCount = 0;
        if(len.length && check === 'test'  && Object.keys(assignor).length !== 0){
            check = 'both';
        }
       
        if(check === 'question'){

            requestType = "question";
            createdCount = progressBarForQuestion.count;
        }else if(check === 'test'){
            createdCount = len.length ?progressBarForQuestion.count:progressBarForTest.count;
            requestType = len.length ? 'question' :'test';
        }else if (check == 'both'){
            requestType = 'both';
        }
         
        return (
            <>
            {requestType !== 'both' && 
            
            <>
            <RequestStepperProcess testDetails={testDetails} questionData={questionData} data={data} overallData={overallData} totalCount={totalCount} trackProgressData={trackProgressData} requestType={requestType} createdCount={createdCount} overallDone={overallDone} match={match} />
            </>
            }
            {requestType === 'both' && this.questionAndTestTrackProgress()}
            </>
        )
    }
}

const mapStateToProps = (state: any) => ({
    accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
    accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
    accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
    progressBarForQuestion: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForQuestion', {}),
    progressBarForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForTest', {}),
    typeOfContent: _.get(state, 'contentRequestData.contentRequestAccordianData.type', ''),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    countZero: contentRequestActions.countZero,
    setType: contentRequestAccordianActions.setType,
}, dispatch);


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(TrackRequestProcess));